// extracted by mini-css-extract-plugin
export var growableInput = "_8m-0";
export var tagContainer = "_8m-2";
export var textInput = "_8m-1";